export default __webpack_public_path__ + "static/airplane-c1d9548a233edc2df6409b0061eabe31.svg";